
import { Post, Get } from "../../helpers/apicalls/apicalls";
import * as actionTypes from "./AiKeywordsTypes";
import { message } from "antd";

export const getAiKeywords = (data, token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_AIKEYWORDS,
    });
    Get(`/agents/user/keywords/${data}`, token)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.AIKEYWORDS_DATA_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.AIKEYWORDS_DATA_FAILED
          });
        }
      })
      .catch((err) => {
        message.error(`${err?.message}`)
        dispatch({
          type: actionTypes.AIKEYWORDS_DATA_FAILED
        });
      });
  };
};

export const saveAiKeywords = (data, token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_SAVE_AIKEYWORDS,
    });
    Post(`/agents/user/keywords`, data, token)
      .then((res) => {
        if (res.status) {
          message.success(`${res?.message}`)
          dispatch({
            type: actionTypes.SAVE_AIKEYWORDS_DATA_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.SAVE_AIKEYWORDS_DATA_FAILED
          });
        }
      })
      .catch((err) => {
        message.error(`${err?.message}`)
        dispatch({
          type: actionTypes.SAVE_AIKEYWORDS_DATA_FAILED
        });
      });
  };
};

